/**
 * Calculate Jaro-Winkler similarity (excellent for names and short strings)
 */
const jaroWinklerSimilarity = (s1, s2) => {
  if (!s1 || !s2) return 0
  if (s1 === s2) return 1

  const len1 = s1.length
  const len2 = s2.length
  const matchWindow = Math.floor(Math.max(len1, len2) / 2) - 1

  if (matchWindow < 0) return 0

  const s1Matches = new Array(len1).fill(false)
  const s2Matches = new Array(len2).fill(false)

  let matches = 0
  let transpositions = 0

  // Find matches
  for (let i = 0; i < len1; i += 1) {
    const start = Math.max(0, i - matchWindow)
    const end = Math.min(i + matchWindow + 1, len2)

    for (let j = start; j < end; j += 1) {
      if (s2Matches[j] || s1[i] !== s2[j]) {
        // eslint-disable-next-line no-continue
        continue
      }
      s1Matches[i] = true
      s2Matches[j] = true
      matches += 1
      break
    }
  }

  if (matches === 0) return 0

  // Find transpositions
  let k = 0
  for (let i = 0; i < len1; i += 1) {
    if (!s1Matches[i]) {
      // eslint-disable-next-line no-continue
      continue
    }
    while (!s2Matches[k]) k += 1
    if (s1[i] !== s2[k]) transpositions += 1
    k += 1
  }

  const jaro = (matches / len1 + matches / len2 + (matches - transpositions / 2) / matches) / 3

  // Winkler bonus for matching prefix
  let prefix = 0
  for (let i = 0; i < Math.min(len1, len2, 4); i += 1) {
    if (s1[i] === s2[i]) {
      prefix += 1
    } else {
      break
    }
  }

  return jaro + (0.1 * prefix * (1 - jaro))
}

export default jaroWinklerSimilarity
